<template>
	<div class="Flogin">
		<!--登录-->
		<template v-if="loginActive == '1'">
			<div class="welcome">
				<img class="wcImg" src="../../../../static/FreshCabinet/images/courier_login_title.png" alt="">
				<span class="wcText">{{Language.LG.LoginTit[isLanguage]}}</span>
			</div>
			<div class="EloginCont">
				<div class="item">
					<label class="itLabel">{{Language.LG.IdTit[isLanguage]}}</label>
					<input class="itInput" type="number" v-model="loginform.Phone" @input="reTime"/>
				</div>
				<div class="item">
					<label class="itLabel">{{Language.LG.PinTit[isLanguage]}}</label>
					<input class="itInput" type="password" v-model="loginform.PassWord" :placeholder="Language.LG.Minimum[isLanguage]" @input="reTime"/>
				</div>
				<div class="item">
					<button type="primary" class="loginBtn" @click="LoginForm">{{Language.LG.Login[isLanguage]}}</button>
				</div>
				<div class="item item_Btn">
					<span class="item_Text" @click="toForgetOrRegister('2')">{{Language.LG.Forget[isLanguage]}}</span>
					<!-- |<span class="item_Text" @click="toForgetOrRegister('3')">{{Language.LG.Registration[isLanguage]}}</span> -->
				</div>
			</div>
		</template>
		
		<!--忘记密码-->
		<template v-else-if="loginActive == '2'">
			<div class="welcome">
				<span class="wcText">{{Language.LG.RetrievePw[isLanguage]}}</span>
			</div>
			<div class="EloginCont">
				<div class="item">
					<label class="itLabel">{{Language.LG.IdTit[isLanguage]}}</label>
					<input class="itInput" type="number" v-model="loginform.Phone" @input="reTime2"/>
				</div>
				<div class="item">
					<label class="itLabel">{{Language.LG.newPinTit[isLanguage]}}</label>
					<input class="itInput" type="password" v-model="loginform.PassWord" :placeholder="Language.LG.Minimum[isLanguage]" @input="reTime2"/>
				</div>
				<div class="item">
					<label class="itLabel">{{Language.LG.verificationCode[isLanguage]}}</label>
					<input class="itInput" type="number" v-model="loginform.Code" @input="reTime2"/>
					<div class="codeBtn">
						<span class="codeText" @click="sendSmsCode()">{{Language.LG.SmsOtp[isLanguage]}}</span>
						<!-- |<span class="codeText" @click="sendSmsVoiceCode()">{{Language.LG.VoiceCode[isLanguage]}}</span> -->
					</div>
				</div>
				<div class="item">
					<button type="primary" class="loginBtn" @click="getBackPassword">{{Language.LG.Confirm[isLanguage]}}</button>
				</div>
			</div>
		</template>
		
		<!--账号注册-->
		<template v-else>
			<div class="welcome welcome_Rg">
				<span class="wcText">{{Language.LG.RegistAcountTit[isLanguage]}}</span>
			</div>
			<div class="ewm">
				<div class="topBor"></div>
				<!--注册二维码-->
				<img class="img" :src="regEwm" alt="">
				<div class="bottomBor"></div>
			</div>
			<div class="RaTips">{{Language.LG.RegistAcountTips[isLanguage]}}</div>
		</template>
		
		<!--超时组件-->
		<overTime :callBack="quit"></overTime>
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>
		<!--loading -->
		<ELoading v-if="isLoading" :LoadingType="'2'"></ELoading>
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import ELoading from '../assets/Loading.vue'
	import { EloginApi } from '../../../../static/FreshCabinet/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	import * as config from '../../../../static/js/config.js';
	var vm
	export default {
		name:'FLogin',
		data() {
			return {
				
				isLanguage:0,
				Language:'',
				
				loginform:{
					Phone:'',//手机号
					PassWord:'',//密码
					Code:'',//验证码
					validCode:'',//接口返回验证码
				},
				
				regEwm:'',//注册的二维码
				
				loginActive:'1',//显示内容
				isLoading:false,//是否显示loading组件
			};
		},
		mounted(){
			
		},
		created(){
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			
			this.$store.state.overTime = 80
			vm = this
		},
		components:{
			overTime,
			EConfigBtn,
			ELoading
		},
		methods:{
			
			//找回密码
			async getBackPassword(){
				let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
				if (vm.loginform.Phone === '') {
					vm.$message({
						message: '请输入手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(!rePhone.test(vm.loginform.Phone)){
					vm.$message({
						message: '请输入正确手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}
				if (vm.loginform.PassWord === '') {
					vm.$message({
						message: '请输入密码',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(vm.loginform.PassWord.length<6){
					vm.$message({
						message: '最少输入6位密码',
						type: 'error',
						duration:1000
					});
				  return false
				}
				if(vm.loginform.validCode != vm.loginform.Code){
					vm.$message({
						message: '验证码错误，请重新输入',
						type: 'error',
						duration:1000
					});
					return false
				}
				const _obj = {
					'phone_no': vm.loginform.Phone,
					'password': vm.loginform.PassWord,
					'user_type': '2',
				}
				let data = {
					'company_name':vm.configStorage.company_name,//公司名称
					'is_md5':'2',//是否md5加密，1加密，2明文
					'validcode':vm.loginform.Code,//验证码
					'user_data': _obj,//用户数据
				}
				const res = await EloginApi.getBackPassword(data)
				conLog('找回密码',res)
				if(res){
					if(res.meta.code == 200){
						vm.$message({
							message: '已更新密码',
							type: 'success',
							duration:1000
						});
						vm.loginform.PassWord=''
						vm.loginform.Code=''
						vm.loginform.validCode=''
						vm.loginActive = '1'
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//登录
			async LoginForm(){
				let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
				if (vm.loginform.Phone === '') {
					vm.$message({
						message: '请输入手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(!rePhone.test(vm.loginform.Phone)){
					vm.$message({
						message: '请输入正确手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}
				if (vm.loginform.PassWord === '') {
					vm.$message({
						message: '请输入密码',
						type: 'error',
						duration:1000
					});
				  return false
				}
				else if(vm.loginform.PassWord.length<6){
					vm.$message({
						message: '最少输入6位密码',
						type: 'error',
						duration:1000
					});
				  return false
				}
				let data = {
					'DeviceId': config.deviceId,
					'PhoneNo': vm.loginform.Phone,
					'Password': vm.loginform.PassWord,
				}
				conLog('data',data)
				vm.isLoading = true
				let res = await EloginApi.userLogin(data)
				conLog('快递员登录',res)
				if(res){
					if(res.ErrCode == 0){
						storage.localSetItem('courierToken', res.Result.Token);
						storage.localSetItem('userInfo', res.Result.UserInfo);
						vm.$message({
							message: '登录成功！',
							type: 'success',
							duration:1000
						});
						vm.isLoading = false
						setTimeout(function(){
							vm.$router.push({
								path:'/FreshCabinet/FDeliveryType'
							})
						},2000)
					}else{
						vm.isLoading = false
						vm.$message({
							message: res.ErrMsg,
							type: 'error',
							duration:1000
						});
					}
				}else{
					vm.isLoading = false
				}
			},
			//发送短信验证码
			async sendSmsCode(){
				let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
				if (vm.loginform.Phone === '') {
					vm.$message({
						message: '请输入手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(!rePhone.test(vm.loginform.Phone)){
					vm.$message({
						message: '请输入正确手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}
				let data = {
					'phone':vm.loginform.Phone,
					'company': vm.configStorage.company_name,
				}
				vm.$message({
					message: '已发送验证码到指定手机',
					type: 'success',
					duration:1000
				});
				// let res = await EloginApi.sendSmsCode(data)
				// conLog('发送短信验证码',res)
				// if(res){
				// 	if(res.meta.code == 200){
				// 		vm.loginform.validCode = res.body.validcode
				// 		vm.$message({
				// 			message: '已发送验证码到指定手机',
				// 			type: 'success',
				// 			duration:1000
				// 		});
				// 	}else{
				// 		vm.$message({
				// 			message: res.meta.message,
				// 			type: 'error',
				// 			duration:1000
				// 		});
				// 	}
				// }
			},
			//发送短信语音验证码
			async sendSmsVoiceCode(){
				let rePhone = new RegExp( /^1[3|4|5|7|8|9][0-9]\d{8}$/)
				if (vm.loginform.Phone === '') {
					vm.$message({
						message: '请输入手机号',
						type: 'error',
						duration:1000
					});
				  return false
				}else if(!rePhone.test(vm.loginform.Phone)){
					vm.$message({
						message: '请输入正确手机号',
						type: 'error',
						duration:1000
					});
				  return
				}
				let data = {
					'phone':vm.loginform.Phone,
				}
				vm.loginform.validCode = res.body.validcode
				vm.$message({
					message: '已发送语音验证码到指定手机',
					type: 'success',
					duration:1000
				});
				// let res = await EloginApi.sendSmsVoiceCode(data)
				// conLog('发送短信语音验证码',res)
				// if(res){
				// 	if(res.meta.code == 200){
				// 		vm.loginform.validCode = res.body.validcode
				// 		vm.$message({
				// 			message: '已发送语音验证码到指定手机',
				// 			type: 'success',
				// 			duration:1000
				// 		});
				// 	}else{
				// 		vm.$message({
				// 			message: res.meta.message,
				// 			type: 'error',
				// 			duration:1000
				// 		});
				// 	}
				// }
			},
			//获取注册二维码
			async getRegisterEwm(){
				let data = {
					'id': vm.configStorage.deviceId,
				}
				// let res = await EloginApi.getRegisterEwm(data)
				// if(res){
				// 	if(res.meta.code == 200){
				// 		vm.regEwm = res.body.dimensional
				// 	}
				// }
			},
			
			//重置时间
			reTime(){
				vm.$store.state.overTime = 80
			},
			reTime2(){
				vm.$store.state.overTime = 120
			},
			//找回密码
			toForgetOrRegister(type){
				if(type == '2'){
					vm.$store.state.overTime = 120
				}else if(type == '3'){
					vm.getRegisterEwm()
					vm.$store.state.overTime = 80
				}
				vm.loginActive = type
				vm.loginform = {
					// Phone:'',//手机号
					PassWord:'',//密码
					Code:'',//验证码
					validCode:'',
				}
			},
			//返回上一页
			backUp(){
				if(vm.loginActive == '1'){
					vm.quit()
				}else{
					vm.$store.state.overTime = 80
					vm.loginActive = '1'
				}
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/FreshCabinet'
				})
			}
		},
		watch :{
			
		},
		
	}
</script>

<style lang="less">
.Flogin{
	position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
	background: #f2f2f2;
	text-align: center;
	.ewm{
		width: 4rem;
		height: 4rem;
		margin: 0 auto;
		position: relative;
		.img{
			width: 3.5rem;
			height: 3.5rem;
			margin: 0.25rem auto;
		}
		.topBor{
			position: absolute;
			width: 100%;
			&::before{
				content: "";
				width: 0.9rem;
				height: 0.9rem;
				position: absolute;
				left: 0;
				top: 0;
				border-top: 0.05rem solid #151c36;
				border-left: 0.05rem solid #151c36;
			}
			&::after{
				content: "";
				width: 0.9rem;
				height: 0.9rem;
				position: absolute;
				right: 0;
				top: 0;
				border-top: 0.05rem solid #151c36;
				border-right: 0.05rem solid #151c36;
			}
		}
		.bottomBor{
			position: absolute;
			width: 100%;
			bottom: 0;
			&::before{
				content: "";
				width: 0.9rem;
				height: 0.9rem;
				position: absolute;
				left: 0;
				bottom: 0;
				border-bottom: 0.05rem solid #151c36;
				border-left: 0.05rem solid #151c36;
			}
			&::after{
				content: "";
				width: 0.9rem;
				height: 0.9rem;
				position: absolute;
				right: 0;
				bottom: 0;
				border-bottom: 0.05rem solid #151c36;
				border-right: 0.05rem solid #151c36;
			}
		}
	}
	.RaTips{
		color: #151c36;
		font-size: 0.45rem;
		margin: 0.3rem 0;
	}
	.EloginCont{
		width: 40%;
		margin: 0.2rem auto;
		.item{
			margin-bottom: 0.2rem;
			display: flex;
			align-items: stretch;
			justify-content: center;
			position: relative;
			.codeBtn{
				position: absolute;
				left: 100%;
				top: 0;
				color: #151c36;
				white-space: nowrap;
				line-height: 0.7rem;
				font-size: 0.26rem;
				.codeText{
					margin: 0 0.1rem;
				}
			}
			&.item_Btn{
				font-size: 0.26rem;
				color:#151c36;
				cursor: pointer;
				text-decoration: underline;
				.item_Text{
					margin: 0 0.1rem;
				}
			}
			.loginBtn{
				line-height: 1 !important;
				padding: 0.3rem 0.5rem;
				border-radius: 0.15rem;
				background: #151c36;
				font-size: 0.3rem;
			}
			.itLabel{
				background: #151c36;
				border-top-left-radius: 0.1rem;
				border-bottom-left-radius: 0.1rem;
				flex-shrink: 0;
				min-width: 35%;
				height: 0.7rem;
				line-height: 0.7rem;
				font-size: 0.3rem;
			}
			.itInput{
				height: 0.7rem;
				min-height: 0.7rem;
				border-top-right-radius: 0.1rem;
				border-bottom-right-radius: 0.1rem;
				flex-grow: 1;
				text-align: left;
				padding: 0 0.1rem;
				box-sizing: border-box;
				border: 0.02rem solid #ddd;
				box-shadow: 0 0.02rem 0.03rem 0 rgba(0,0,0,.16);
				font-size: 0.3rem;
				color: #666;
				background: #fff;
			}
		}
	}
	.welcome{
		padding: 0.3rem 0;
		.wcImg{
			width: 4.42rem;
			height: 0.87rem;
		}
		.wcText{
			font-size: 0.45rem;
			color: #151c36;
			display: block;
		}
		&.welcome_Rg{
			padding-top: 1.2rem;
		}
	}
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/login/login.vue